import type { BankAccountIdentifierValueRes } from '@dealstack/shared/lib/generated';

import { FORMAT_INDEPENDENT_IDENTIFIER_KEYS } from '../../BankAccountForm.utils';

// Rows linked to a rule are excluded — the save sweeps any whose rule is not the one
// being submitted, so showing them would promise data that is about to go. A key this
// tab renders is excluded too: its own field prefills from the same row.

/**
 * Stored values the account carries that this tab renders nowhere. Without them a
 * bank name captured by an earlier lookup is invisible while editing, even though it
 * is kept on save and titles the account's tile.
 */
export const getStoredSummaryRows = (
	identifiers: BankAccountIdentifierValueRes[] | undefined,
	ruleFieldKeys: ReadonlySet<string>,
	labelFor: (key: string) => string
): { key: string; label: string; value: string }[] =>
	FORMAT_INDEPENDENT_IDENTIFIER_KEYS.filter((key) => !ruleFieldKeys.has(key))
		.map((key) => ({
			key,
			label: labelFor(key),
			value:
				(identifiers ?? []).find(
					(identifier) => identifier.key === key && !identifier.bankAccountFormatRuleId
				)?.value ?? '',
		}))
		.filter((row) => !!row.value);
